// Title constants
export const MAIN_HEADER_TITLE_TEXT = 'Booking system'
export const CHECK_ROOM_TITLE_TEXT = 'Check Room'
export const HOME_TITLE_TEXT = 'Hotel Booking App'
export const ADD_BOOKING_TITLE_TEXT = 'Add Booking'

// Sidebar constants
export const HOME_LINK_TEXT = 'Home'
export const ADD_BOOKING_LINK_TEXT = 'Add Booking'
export const CHECK_ROOM_LINK_TEXT = 'Check Room'

// Button constants
export const ADD_BUTTON_TEXT = 'Add'
export const CHECK_BUTTON_TEXT = 'Check'

// Alert message constants
export const SURNAME_ERROR_TEXT = 'Please provide a valid surname'
export const ROOM_ERROR_TEXT = 'Please select a room'
export const DATE_ERROR_TEXT = 'Please select a date'
export const ADD_BOOKING_SUCCESS_TEXT = 'Room has been booked!'
export const ROOM_AVAILABLE_TEXT = 'Room is available'
export const ROOM_NOT_AVAILABLE_TEXT = 'Room is not available'
